
export * from './src/toast/Itoast';
export * from './src/toast/toast.component';
export * from './src/toast/toaster.component';
export * from './src/toast/toaster.service';


// WEBPACK FOOTER //
// ./~/angular2-toastr/index.ts